import React, { PureComponent } from 'react';
import { withNamespaces } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

class NotLoggedInMenuMobile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
  }

  toggleMenu = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen,
    });
  };

  showLogin = () => {
    this.props.showLogin();
    this.toggleMenu();
  };

  render() {
    const { t, createNewsroomLink } = this.props;

    return (
      <div>
        <button
          onClick={this.toggleMenu}
          className="mnd-mobile-menu__open-button"
        >
          <span className="screen-reader-only">Toggle</span>
          <i className="fas fa-bars" />
        </button>
        <div
          className={classnames('mnd-mobile-menu', {
            open: this.state.isMenuOpen,
          })}
        >
          <button
            onClick={this.toggleMenu}
            className="mnd-mobile-menu__close-button"
          >
            <span className="screen-reader-only">Toggle</span>
            <i className="fas fa-times" />
          </button>
          <ul className="mnd-navigation-menu">
            <li className="mnd-navigation-menu__item">
              <NavLink
                to={{
                  pathname: '/',
                }}
                isActive={(match, location) =>
                  location.pathname === '/' ||
                  location.pathname === '/stories' ||
                  location.pathname === '/organisations'
                }
                activeClassName="mnd-navigation-menu__item-hitarea--active"
                className="mnd-navigation-menu__item-hitarea mnd-button--link"
              >
                {t('common_navigation-menu_title-stories')}
              </NavLink>
            </li>
            <li className="mnd-navigation-menu__item">
              <a
                href={createNewsroomLink}
                className="mnd-navigation-menu__item-hitarea mnd-button--link"
              >
                {t('common_navigation-menu_title-product')}
              </a>
            </li>
            <li className="mnd-navigation-menu__item-separator" />
            <li className="mnd-navigation-menu__item">
              <button
                onClick={this.showLogin}
                className="mnd-navigation-menu__item-hitarea mnd-button--link"
              >
                <i className="fas fa-key" />
                {t('global_navigation-link_authenticate')}
              </button>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

NotLoggedInMenuMobile.defaultProps = {
  site: {},
};
export default withNamespaces()(NotLoggedInMenuMobile);
